import i18next, { type i18n as I18nInstance, type InitOptions } from 'i18next';
import ICU from 'i18next-icu';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { resolveLocale } from '../locales';
import type { LocaleCode } from '../types';
import { syncHtmlDir } from '../rtl';

const STORAGE_KEY = 'pulse.locale';

export async function createWebI18nFromConfig(
  sharedConfig: InitOptions,
  initialLocale?: LocaleCode,
): Promise<I18nInstance> {
  const instance = i18next.createInstance();

  const config: InitOptions = {
    ...sharedConfig,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: STORAGE_KEY,
      caches: ['localStorage'],
      convertDetectedLanguage: (raw: string) => resolveLocale(raw),
    },
    ...(initialLocale !== undefined ? { lng: initialLocale } : {}),
  };

  await instance.use(ICU).use(LanguageDetector).use(initReactI18next).init(config);

  // Sync <html dir> on boot and on every change.
  const apply = () => syncHtmlDir(resolveLocale(instance.language));
  apply();
  instance.on('languageChanged', apply);

  return instance;
}
